// React
import { FunctionComponent, JSXElementConstructor, ReactElement } from "react";
// Components
import { Page, PageConfiguration } from "@fyrstain/hl7-front-library";
// Translation
import i18n from "i18next";
// Authentication
import UserService from "../../services/UserService";
// Navigation
import { useNavigate } from "react-router-dom";
import { toPublicUrl } from "../../services/PublicUrl";


const VestaPage: FunctionComponent<{
    // The title of the page
    titleKey?: string;
    // The loading state of the page
    loading?: boolean;
    // The content of the page
    children?: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
    // Fit the footer to the bottom of the page
    fitFooter?: boolean;
    // If the page needs login or not
    needsLogin: boolean;
}> = (props) => {

    /////////////////////////////////
    //        NAVIGATION           //
    /////////////////////////////////

    const navigate = useNavigate();
       
   /////////////////////////////////
    //           METHODS           //
    /////////////////////////////////

    const handleLangChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    const handleNavbarLogoClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target as Element;

        if (target.closest(".navbar-brand")) {
            event.preventDefault();
            navigate("/");
        }
    };

    const fullConfig: PageConfiguration = {
        // Translation
        language: i18n.t,
        navigationBarConfigs: {
            // Application logo (modification delete logowidth)
            logoLink: toPublicUrl("/assets/logo.png"),
            alt: 'Application Logo',
            // Authentication            
            authentication: {
                doLogin: UserService.doLogin,
                doLogout: UserService.doLogout,
                isAuthenticated: () => UserService.isAuthenticated() || false,
                getUserName: () => UserService.getUsername(),
            },
            // the menu items with their subItems who contains the navigation to the differents pages
            menuItems: [
                {
                    title: i18n.t('navbar.items.page'),
                    link: toPublicUrl("/Calendar"),
                },
            ],
            // the user items 
            // Admin, Login, Logout are the default items
            dropDownItems: [],
        },
        // the title of the page
        titleKey: props.titleKey,
        // the loading state of the page
        loading: props.loading,
        // the content of the page
        children: props.children,
        // if the page needs login or not
        needsLogin: props.needsLogin,
        isAuthenticated: () => UserService.isAuthenticated() || false,
        doLogin: UserService.doLogin,
        footerConfigs: {
            languages: {
                default: i18n.language,
                onChange: handleLangChange,
                options: [
                    {
                        label: "English",
                        value: "en"
                    },
                    {
                        label: "Français",
                        value: "fr"
                    }
                ]
            },
            logo: [
                {
                    logoLink: "https://fyrstain.com/wp-content/uploads/2022/10/Logo_fyrstain_horyzontal.svg",
                    alt: "Horizontal logo type",
                    link: toPublicUrl("/Home")
                },
                ...(process.env.REACT_APP_DISPLAY_CLIENT_LOGO === 'true' ?
                    [
                        {
                            logoLink: "https://fyrstain.com/wp-content/uploads/2022/10/Logo_fyrstain_horyzontal.svg",
                            alt: "Horizontal logo type",
                            link: toPublicUrl("/Home"),
                        },
                        {
                            logoLink: toPublicUrl("/assets/client_logo.jpg"),
                            alt: "HL7 Europe logo"
                        }
                    ]
                    : [])
            ],
            items: [
                {
                    label: i18n.t("footer.items.about"),
                    link: toPublicUrl("/InProgress"),
                },
                {
                    label: i18n.t("footer.items.contact"),
                    link: toPublicUrl("/InProgress"),
                },
                {
                    label: i18n.t("footer.items.problemtracking"),
                    link: toPublicUrl("/InProgress"),
                },
            ],
            implementationGuide: {
                label: i18n.t("footer.items.implementationguide"),
                link: toPublicUrl("/ImplementationGuide"),
            },
 
        }
    };

    return (
        <div onClickCapture={handleNavbarLogoClick}>
            <Page {...fullConfig} />
        </div>
    );
};

export default VestaPage;
